module.exports = __webpack_public_path__ + "img/aptos.f2749511.png";